import {Chat, User} from '@layer';

export default function getPeerActiveUsernames(peer: User | Chat) {
  if(!peer) {
    return [];
  }

  // Manager-control fork: hide ALL client (user) usernames everywhere they
  // flow from here — profile, title fallback, search, mentions, and any
  // t.me/<username> link. Channels/groups keep their public usernames.
  if(peer._ === 'user') {
    return [];
  }

  const usernames = (peer as Chat.channel).usernames;
  if(usernames) {
    return usernames
    .filter((username) => username.pFlags.active)
    // .sort((a, b) => +!!b.pFlags.editable - +!!a.pFlags.editable)
    .map((username) => username.username);
  }

  return (peer as Chat.channel).username ? [(peer as Chat.channel).username] : [];
}
